import { CustomerSettings, CustomerSettingsContext } from "@Safemate/Store/settingsProvider";
import { AppState } from "@Safemate/Store/types";
import * as React from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import styled from "styled-components";

const WarningHeader = styled.div`
  padding: 10px 0px;
  color: red;
`;

interface ClimaxConfigWarningProps{
  customerId: number;
}

const mapStateToProps = ({ defaultSettings: { customer: { selectedCustomer: { customerId } } } }: AppState) => {
  return{
    customerId
  }
}

export const ClimaxConfigWarning = connect(mapStateToProps)(({ customerId }: ClimaxConfigWarningProps) => {

  const customerSettings = React.useContext(CustomerSettingsContext) as CustomerSettings;
  const settingsForCustomer = customerSettings[customerId];

  const { formatMessage } = useIntl();

  if(!settingsForCustomer.climaxConfig) return null;

  return(
    <WarningHeader>{formatMessage({id: "climaxConfigWarningSettings", defaultMessage: "Customer have devices that communicate to another endpoint."})}</WarningHeader>
  )
})